

















import { Component, Prop, Vue, Emit } from 'vue-property-decorator'

@Component({})
export default class GlobalFooter extends Vue {
	@Prop({
		type: Array,
		default: () => {
			return []
		},
	})
	private links!: any[]

	private to(item: any) {
		if (!item.href) {
			return
		}
		if (item.blankTarget) {
			;(window as any).open(item.href)
			return
		}
		if (/^https?:\/\//.test(item.href)) {
			;(window as any).location.href = item.href
		} else {
			this.$router.push(item.href)
		}
	}
}
